import { _ as __assign } from '../../chunks/bundle-Ca6003_X.js';
import React__default from 'react';
import { b as useGroupChannelContext, u as useGroupChannel } from '../../chunks/bundle-CGu41Cov.js';
import { G as GroupChannelUIView } from '../../chunks/bundle-w4rtGONt.js';
import { GroupChannelHeader } from './GroupChannelHeader.js';
import { MessageList } from './MessageList.js';
import { MessageInputWrapper } from './MessageInputWrapper.js';
import { d as deleteNullish } from '../../chunks/bundle-91Yg-xh6.js';
import '@sendbird/chat/message';
import '@sendbird/chat/groupChannel';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-C6mXReBM.js';
import '../../chunks/bundle-ByN2OJfK.js';
import '../../chunks/bundle-Dcb1dUnS.js';
import '../../chunks/bundle-BSmdL6m-.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-Dwuqku8L.js';
import '../../chunks/bundle-DxuHs_7y.js';
import '../../chunks/bundle-DgPFpYZt.js';
import '../../chunks/bundle-CyNQH9Yl.js';
import '../../chunks/bundle-B2eoNpzc.js';
import '../../chunks/bundle-_G98ZxIs.js';
import '../../chunks/bundle-CiiVQ3uH.js';
import '../../chunks/bundle-DrrIZ2Uk.js';
import './TypingIndicator.js';
import '../../chunks/bundle-DDzCV2KR.js';
import '../../chunks/bundle-DLMIiDGU.js';
import '../../chunks/bundle-s19NuPaM.js';
import '../../chunks/bundle-DGylLBIn.js';
import '../../chunks/bundle-C6Xiexo0.js';
import '../../chunks/bundle-CQqATdFh.js';
import '../../ui/ConnectionStatus.js';
import '../../ui/Icon.js';
import '../../ui/PlaceHolder.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-ByFIDXba.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-zHBlW_wn.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_bjYbrN.js';
import '../../chunks/bundle-DMGc5oMP.js';
import '../../chunks/bundle-DvRfv6gQ.js';
import '../../chunks/bundle-BVK-TCRK.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DDAJSpJT.js';
import '../../chunks/bundle-DUh4gAyx.js';
import '../../chunks/bundle-CPSJLEbT.js';
import '../../ui/Header.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DMyARZj7.js';
import '../../ui/IconButton.js';
import './Message.js';
import '../../chunks/bundle-C2JTgyt9.js';
import '../../chunks/bundle-DUxsnVl5.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/DateSeparator.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-B667kaG5.js';
import '../../ui/Button.js';
import '../../chunks/bundle-y-5JpD-m.js';
import 'dompurify';
import '../../chunks/bundle-DgkSQIK-.js';
import '../../chunks/bundle-C6zIjPZB.js';
import '../../chunks/bundle-rD5ecRD2.js';
import '../../chunks/bundle-DvAn8oVD.js';
import '../../ui/MessageContent.js';
import '../../chunks/bundle-Bvt5IYi6.js';
import '../../chunks/bundle-yAJ3x9FL.js';
import '../../chunks/bundle-CGyTyL9F.js';
import '../../chunks/bundle-DWIeaywD.js';
import '../../chunks/bundle-MWMmhBLS.js';
import 'react-dom';
import '../../ui/SortByRow.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ReactionButton.js';
import '../../chunks/bundle-CCadcyYR.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-CCo7ZdMR.js';
import '../../ui/UserListItem.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../Message/context.js';
import '../../ui/AdminMessage.js';
import '../../ui/QuoteMessage.js';
import '../../chunks/bundle-QUexVbet.js';
import '../../ui/MobileMenu.js';
import '../../ui/ThreadReplies.js';
import '../../chunks/bundle-wQHmlETP.js';
import '../../ui/OGMessageItemBody.js';
import '../../chunks/bundle-DoY2J3ED.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/TextMessageItemBody.js';
import '../../ui/FileMessageItemBody.js';
import '../../chunks/bundle-ByGwtLlZ.js';
import '../../ui/FileViewer.js';
import '../../chunks/bundle-IdVJHm4l.js';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-x5dO2c1K.js';
import '../../VoiceRecorder/context.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import '../../ui/TemplateMessageItemBody.js';
import '../../chunks/bundle-Cqoa9SwC.js';
import '../../ui/FallbackTemplateMessageItemBody.tsx.js';
import '../../ui/LoadingTemplateMessageItemBody.tsx.js';
import '../../ui/MessageFeedbackFailedModal.js';
import '../../ui/FeedbackIconButton.js';
import '../../ui/MobileFeedbackMenu.js';
import '../../ui/MessageFeedbackModal.js';
import '../../ui/Input.js';
import '../../chunks/bundle-D05FRFMk.js';
import './SuggestedReplies.js';
import '../../chunks/bundle-MhQ-_j2c.js';
import './FileViewer.js';
import '../../chunks/bundle-BizIEQwt.js';
import './RemoveMessageModal.js';
import '../../chunks/bundle-aoJ63sHH.js';
import '../../chunks/bundle-CK16SjUd.js';
import './UnreadCount.js';
import './FrozenNotification.js';
import '../../ui/TypingIndicatorBubble.js';
import '../../Channel/utils/getMessagePartsInfo.js';
import '../../Channel/utils/compareMessagesForGrouping.js';
import '../../chunks/bundle-BUPAEl-k.js';
import '../../chunks/bundle-BoAtUmX0.js';
import './SuggestedMentionList.js';
import '../../ui/QuoteMessageInput.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-Br7l2qHZ.js';
import '../../chunks/bundle-DqU2mzDL.js';

var GroupChannelUI = function (props) {
    var context = useGroupChannelContext();
    var _a = useGroupChannel().state, channelUrl = _a.channelUrl, fetchChannelError = _a.fetchChannelError;
    // Inject components to presentation layer
    var _b = deleteNullish(props), _c = _b.renderChannelHeader, renderChannelHeader = _c === void 0 ? function (props) { return React__default.createElement(GroupChannelHeader, __assign({}, props)); } : _c, _d = _b.renderMessageList, renderMessageList = _d === void 0 ? function (props) { return React__default.createElement(MessageList, __assign({}, props, { className: "sendbird-conversation__message-list" })); } : _d, _e = _b.renderMessageInput, renderMessageInput = _e === void 0 ? function () { return React__default.createElement(MessageInputWrapper, __assign({}, props)); } : _e;
    return (React__default.createElement(GroupChannelUIView, __assign({}, props, context, { isInvalid: fetchChannelError !== null, channelUrl: channelUrl, renderChannelHeader: renderChannelHeader, renderMessageList: renderMessageList, renderMessageInput: renderMessageInput })));
};

export { GroupChannelUI, GroupChannelUI as default };
//# sourceMappingURL=GroupChannelUI.js.map
